import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const reportStore = new Vuex.Store({
  state: {
    selectedOrder: null,
    selectedReport: null,
    activeBbox: null,
    loadingData: true,
    chain: [
      {
        level: 1,
        dict: {},
        id: '',
        number: '',
        name: ''
      },
      {
        level: 2,
        dict: {},
        id: '',
        number: '',
        name: ''
      }
    ],
    reportsAll: [
      {
        level: 1,
        reports: []
      },
      {
        level: 2,
        reports: []
      }
    ]
  },

  mutations: {
    setReportInChain (state, reportLevelName) {
      let _level = reportLevelName.level
      let _report = reportLevelName.report
      let _name = reportLevelName.name
      let _levelIndex = state.chain.findIndex(item => { return item.level === _level }) // поиск индекса в масииве с уровнями
      // if (_levelIndex === -1) {} // если такого уровня нет(третий и т.д.) создать
      reportStore.dispatch('clearChainFromLevel', _level)
      state.chain[_levelIndex].dict = _report.dict
      state.chain[_levelIndex].id = _report.report_id
      state.chain[_levelIndex].number = state.selectedOrder.order_number
      if (_level !== 1) {
        state.chain[_levelIndex].name = _name
      }
    },
    clearChainFromLevel (state, level) {
      for (let i = 0; i < state.chain.length; i++) {
        if (state.chain[i].level >= level) {
          state.chain[i].dict = {}
          state.chain[i].id = ''
          state.chain[i].number = ''
          state.chain[i].name = ''
        }
      }
    },
    addReport (state, reportAndLevel) {
      let _level = reportAndLevel.level
      let _report = reportAndLevel.report
      let _levelIndex = state.reportsAll.findIndex(item => { return item.level === _level }) // поиск индекса в масииве с уровнями
      if (_levelIndex === -1) { // переданный уровень не нашелся
        console.error('can\'t find index of level ', _level)
        return
      }
      if (state.reportsAll[_levelIndex].reports.findIndex(item => { return (item.report_id === _report.report_id) }) !== -1) { // переданный репорт уже есть в этом уровне
        // console.log('report with id ' + _report.report_id + ' already exist')
        return
      }
      state.reportsAll[_levelIndex].reports.push(_report)
      // console.log('add report', _report)
    },
    setValue (state, keyValue) {
      state[keyValue.key] = keyValue.value
    }
  },

  actions: {
    setReportInChain ({commit}, e) {
      commit('setReportInChain', e)
    },
    clearChainFromLevel ({commit}, level) {
      commit('clearChainFromLevel', level)
    },
    selectReport ({commit}, reportAndLevel) {
      commit('selectReport', reportAndLevel)
    },
    addReport ({commit}, reportAndLevel) {
      commit('addReport', reportAndLevel)
    },
    setValue ({commit}, keyValue) {
      commit('setValue', keyValue)
    }
  },

  getters: {
    report: state => idAndLevel => {
      let id = idAndLevel.id
      let level = idAndLevel.level
      let levelIndex = state.reportsAll.findIndex(item => { return item.level === level })
      return state.reportsAll[levelIndex].reports.find(item => { return item.report_id === id })
    },
    hasReport: state => idAndLevel => {
      let id = idAndLevel.id
      let level = idAndLevel.level
      let levelIndex = state.reportsAll.findIndex(item => { return item.level === level })
      let reportIndex = state.reportsAll[levelIndex].reports.findIndex(item => { return item.report_id === id })
      return reportIndex !== -1
    },
    value: state => key => {
      if (key in state) {
        return state[key]
      } else {
        return null
      }
    }
  }
})

export default reportStore



// WEBPACK FOOTER //
// ./src/storages/reportStore.js